import { BaseModel } from './base.model'
import { Center } from './center.model'
import { HubCourse } from './hub-course.model'
import * as _ from 'lodash'
import { Constants } from 'config'
import { CenterProgram } from './center-program.model'

export interface courseTagName {
  value: number
  display: string
}

export class Hub extends BaseModel<Hub> {
  static DEFAULT_ATTRIBUTES = {
    excludes: [],
    centerIds: [],
    centers: [],
    hubCourses: [],
    courseNames: [],
    courseNameTag: []
  }

  id: number
  name: string
  address: string
  hubCourses: HubCourse[]
  centerIds: number[] = []
  centers: Center[]
  excludes: string
  courseNames: string[]
  utcOffset: number
  courseNameTags: courseTagName[] = []
  smsConfirmation: boolean = false
  centerPrograms: CenterProgram[]

  syncCourses(): void {
    // добавляем новые курсы
    const hubCoursesIds = this.hubCourses.map(hc => hc.id)
    this.courseNameTags.filter(tag => hubCoursesIds.indexOf(tag.value) == -1).forEach(tag => {
      this.hubCourses.push(new HubCourse({
        name: tag.display
      }))
    })
    // обновляем position
    for (let i = 0; i < this.hubCourses.length; i++) {
      this.hubCourses[i].position = i + 1
    }
  }

  constructor(attributes) {
    super(attributes)

    if (this.centers) {
      this.centerIds = this.centers.map(c => c.id)
    }

    if (this.hubCourses) {
      this.courseNames = this.hubCourses.map(c => c.name)

      this.courseNameTags = this.hubCourses.map(hc => ({
        value: hc.id,
        display: hc.name
      }))
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/hub.model.ts